import { merge, bind } from 'ramda';
import moment from 'moment';
import React from 'react';
import autoBind from '../../modules/autoBind';
import { XTNA, XTNAChart, XTNAForm, XTNAResults } from '../xtna';
import { XTNATrabajoChart } from '../xtnaTrabajo';
import { Benzinger, BenzingerChart, BenzingerForm, BenzingerResults } from '../benzinger';
import ExcelDataExtractor from './ExcelDataExtractor.jsx';
import XTNAReportGenerator from './XTNAReportGenerator.jsx';
import HumanFactorsReportGenerator from './HumanFactorsReportGenerator.jsx';
import PersonalDataForm from './PersonalDataForm.jsx';

export default class ReportingTool extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      xtna: merge({ valid: true }, XTNA.default()),
      benzinger: merge({ valid: true }, Benzinger.default()),
      benzingerStats: { i1: 0, i2: 0, e1: 0, e2: 0 },
      personal: { name: '', company: '', age: 0, date: moment(), valid: false },
      benzinger: { L1: 0, A1: 0, V1: 0, I1: 0, L2: 0, A2: 0, V2: 0, I2: 0, valid: true,
        adultoStats: {
          AT: [0, 0, 0, 0],
          ATL: [0, 0, 0, 0],
          AA: [0, 0, 0, 0],
        },
        jovenStats: [0, 0, 0, 0],
        adjetivo: '',
        totalExIn: [0, 0],
        adultoExIn: [0, 0],
        jovenExIn: [0, 0],
        posDetNegEst: [0, 0, 0, 0],
        imagen: ['0', '0', '0', '0'],
      },
    };
  }
  render() {
    const canGenerateXTNAReport = this.state.xtna.valid && this.state.personal.valid && this.props.xtnaReportTemplate && this.props.numLicenses >= 0;
    const canGenerateHumanFactorsReport = this.state.benzinger.valid && this.state.personal.valid && this.props.humanFactorsReportTemplate && this.props.numLicenses >= 0;

    return (
      <div>
        <div className='col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4' style={{ margin: '20px 0px' }}>
          <PersonalDataForm value={this.state.personal} onChange={(value) => this.setState({ personal: value })} />
          <ExcelDataExtractor onChange={bind(this.setState, this)}/>
          <XTNAReportGenerator
            user={this.props.user}
            licenseConsumed={() => 0}
            consumeLicense={this.props.consumeLicense}
            personalData={this.state.personal}
            xtna={this.state.xtna}
            valid={canGenerateXTNAReport}
            chartsIds={{ xtna: 'xtna-chart', xtnaTrabajo: 'xtna-trabajo-chart' }}
            reportTemplateUrl={this.props.xtnaReportTemplate}/>
          <HumanFactorsReportGenerator user={this.props.user} licenseConsumed={() => 0} consumeLicense={this.props.consumeLicense} personalData={this.state.personal} xtna={this.state.xtna} benzinger={this.state.benzinger} valid={canGenerateHumanFactorsReport} chartsIds={{ xtna: 'xtna-chart', benzinger: 'benzinger-chart', xtnaTrabajo: 'xtna-trabajo-chart' }} reportTemplateUrl={this.props.humanFactorsReportTemplate} {...this.state.benzingerStats}/>
        </div>
        <div className='col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4' style={{ margin: '20px 0px' }}>
          <XTNAChart {...this.state.xtna} id='xtna-chart'/>
          <center>
            <XTNAForm value={this.state.xtna} onChange={(value) => this.setState({ xtna: value })} />
          </center>
          <XTNAResults {...this.state.xtna}/>
        </div>
        <div className='col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4' style={{ margin: '20px 0px' }}>
          <BenzingerChart {...this.state.benzinger} id='benzinger-chart'/>
          <center>
          <BenzingerForm value={this.state.benzinger} stats={this.state.benzingerStats} onStatChange={(stats) => this.setState({ benzingerStats: stats })} onChange={(value) => this.setState({ benzinger: value })}/>
          </center>
        </div>
        <div className='col-xs-10 col-xs-offset-1' style={{ margin: '20px 0px' }}>
          <XTNATrabajoChart {...this.state.xtna} id='xtna-trabajo-chart'/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/reports/ReportingTool.jsx